/**
 * KAN-1998 — brána „Budeme s díly něco dělat?" je DOČASNĚ schovaná
 * (vlastník 2026-10-09): košík jde rovnou na pokladnu, jako by zákazník
 * zvolil „jen díly". Podoba se teprve navrhuje — dialog má řídit mapa
 * výroby, ne počet dílů.
 *
 * Vlastní modul jen proto, aby ``tests/AssemblyGate.test.tsx`` mohl
 * bránu zapnout a hlídat ji dál pro chvíli, kdy se vrátí.
 */
export const ASSEMBLY_GATE_ENABLED = false;
